var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { useGalleryMenuContext } from './GalleryMenuProvider';
import { Image } from '@spotify-internal/encore-web';
var Crossfade = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  visibility: ", ";\n  opacity: ", ";\n  z-index: ", ";\n  transition: visibility 0.35s, opacity 0.35s ease-in-out, z-index 0s 0.35s;\n"], ["\n  visibility: ", ";\n  opacity: ", ";\n  z-index: ", ";\n  transition: visibility 0.35s, opacity 0.35s ease-in-out, z-index 0s 0.35s;\n"])), function (_a) {
    var active = _a.active;
    return (active ? 'visible' : 'hidden');
}, function (_a) {
    var active = _a.active;
    return (active ? 1 : 0);
}, function (_a) {
    var active = _a.active;
    return (active ? 1 : 'unset');
});
var ImageWrapper = styled(Image).withConfig({
    shouldForwardProp: function (prop) { return !['active'].includes(prop); }
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  max-width: 100%;\n  position: absolute;\n  object-fit: cover;\n  ", "\n"], ["\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  max-width: 100%;\n  position: absolute;\n  object-fit: cover;\n  ", "\n"])), Crossfade);
export var ActiveLinkImage = function (_a) {
    var className = _a.className;
    var _b = useGalleryMenuContext(), activeGalleryLink = _b.activeGalleryLink, allLinks = _b.allLinks;
    return (React.createElement("div", { className: className, style: {
            position: 'relative',
            aspectRatio: '16 / 9'
        } }, allLinks === null || allLinks === void 0 ? void 0 : allLinks.map(function (link, idx) {
        var _a, _b, _c, _d, _e, _f;
        return (React.createElement(ImageWrapper, { src: (_b = (_a = link === null || link === void 0 ? void 0 : link.image) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.url, key: idx, active: ((_d = (_c = link === null || link === void 0 ? void 0 : link.image) === null || _c === void 0 ? void 0 : _c.file) === null || _d === void 0 ? void 0 : _d.url) === ((_f = (_e = activeGalleryLink === null || activeGalleryLink === void 0 ? void 0 : activeGalleryLink.image) === null || _e === void 0 ? void 0 : _e.file) === null || _f === void 0 ? void 0 : _f.url) }));
    })));
};
var templateObject_1, templateObject_2;
